import React, { Fragment, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Navigation, Autoplay } from "swiper/core";
import "../../assets/styles/homepage/mainslider.scss";
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/navigation/navigation.min.css";

SwiperCore.use([Pagination, Navigation, Autoplay]);

const MainSliderHome = (props) => {
  const [desktopBanners, setDesktopBanners] = useState([
    {
      image: "https://alisuq-production-s3-bucket.s3-me-south-1.amazonaws.com/media/images/2fEhD4PZ6U9otCPziNSWc1.png",
     
    },

    {
        image: "https://alisuq-production-s3-bucket.s3-me-south-1.amazonaws.com/media/images/eAbsfmAjqfe4k7kuXxMGr5.png",
        
    },
  ]);

  return (
    <Fragment>
      <Swiper
        autoplay={{
            delay: 3000, // time in milliseconds between slides (e.g., 3 seconds)
            disableOnInteraction: false, // keep autoplay going even after manual navigation
          }}
          
        slidesPerView={1}
        spaceBetween={30}
        loop={false} // don't loop if only one banner
        pagination={{
          clickable: false,
        }}
        navigation={
          props.screenWidth && props.screenWidth === "sm" ? false : true
        }
        className="homepage-main-banner-swiper"
        dir="ltr"
      >
        {desktopBanners.map((item, index) => (
          <SwiperSlide key={index}>
            {item.redirects_to_link ? (
            
                <img
                  className="swiper-image"
                  style={{
                    width: "100%",
                    height: "100%",
                    maxHeight: "100%",
                    borderRadius: "16px",
                  }}
                  src={props.screenWidth === "sm" ? item.image_mobile || item.image : item.image}
                  alt=""
                />
              
            ) : (
              <img
                className="swiper-image"
                style={{
                  width: "100%",
                  height: "100%",
                  maxHeight: "100%",
                  borderRadius: "16px",
                }}
                src={props.screenWidth === "sm" ? item.image_mobile || item.image : item.image}
                alt=""
              />
            )}
          </SwiperSlide>
        ))}
      </Swiper>
    </Fragment>
  );
};

export default MainSliderHome;
